import {ITheme} from 'contexts/ThemeContext';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  minSize,
} from 'rn-responsive-styles';

export default ({colors, typography}: ITheme) =>
  CreateResponsiveStyle(
    {
      tooltipWrapper: {
        paddingHorizontal: 12,
        paddingVertical: 8,
        backgroundColor: colors.lavenderWeb,
        borderRadius: 8,
        gap: 8,
        boxShadow: `0px 4px 0px ${colors.transparentPrimary}`,
      },
      tooltipWrapperNoShadow: {
        paddingHorizontal: 12,
        paddingVertical: 8,
        backgroundColor: colors.lavenderWeb,
        borderRadius: 8,
        gap: 8,
      },
      tooltipItemWrapper: {
        alignItems: 'center',
        gap: 10,
        paddingBottom: 8,
        flexDirection: 'row',
        flexWrap: 'nowrap',
      },

      colorBlock: {
        width: 12,
        height: 12,
      },
      tooltipTextStyle: {
        lineHeight: 18,
        fontSize: 12,
        ...typography.interRegular,
      },
      toolipHeaderAndPercentTextStyle: {
        lineHeight: 18,
        fontSize: 12,
        ...typography.interSemiBold,
      },
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {},
    },
  )();
